import { currency } from "../../utils/number.utils";

export default function StockListPrice({ sale, asking }) {
  return (
    <div>
      <div>
        <del>{currency(asking)}</del>
      </div>
      <div>{currency(sale)}</div>
    </div>
  );
}
